// extracted by mini-css-extract-plugin
export default {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__7MNn0","subTitleBold":"BoxSubTitle_subTitleBold__wtbid"};